var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownRoundedFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22386 10.3501L11.4634 14.7681C11.7602 15.0773 12.2406 15.0773 12.5366 14.7681L16.7761 10.3501C17.2543 9.8518 16.9158 9 16.2396 9L7.76045 9C7.08421 9 6.74572 9.8518 7.22386 10.3501Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRoundedFigma);
export default __webpack_public_path__ + "static/media/dropdown-rounded-figma.cdbf90628a93f9d38a3530a13dc2b7a9.svg";
export { ForwardRef as ReactComponent };